"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const URLs_1 = require("../utility/URLs");
function Home(props) {
    const [statistics, setstatistics] = react_1.default.useState();
    react_1.default.useEffect(() => {
        (0, URLs_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.home(); }), setstatistics, 'Home', true);
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", null,
            "\u0639\u062F\u062F \u0627\u0644\u0635\u0641\u062D\u0627\u062A: ", statistics === null || statistics === void 0 ? void 0 :
            statistics.pagesCount),
        react_1.default.createElement("div", null,
            "\u0639\u062F\u062F \u0627\u0644\u062A\u0635\u0646\u064A\u0641\u0627\u062A: ", statistics === null || statistics === void 0 ? void 0 :
            statistics.categoriesCount),
        react_1.default.createElement("div", null,
            "\u0639\u062F\u062F \u0627\u0644\u0643\u062A\u0628: ", statistics === null || statistics === void 0 ? void 0 :
            statistics.booksCount),
        react_1.default.createElement("div", null,
            "\u0639\u062F\u062F \u0627\u0644\u0643\u062A\u0628 \u0627\u0644\u0645\u0641\u0639\u0644\u0629: ", statistics === null || statistics === void 0 ? void 0 :
            statistics.activatedBooksCount),
        react_1.default.createElement("div", null,
            "\u0639\u062F\u062F \u0627\u0644\u0645\u0642\u0627\u0644\u0627\u062A: ", statistics === null || statistics === void 0 ? void 0 :
            statistics.articlesCount),
        react_1.default.createElement("div", null,
            "\u0639\u062F\u062F \u0627\u0644\u0645\u0642\u0627\u0644\u0627\u062A \u0627\u0644\u0645\u0641\u0639\u0644\u0629: ", statistics === null || statistics === void 0 ? void 0 :
            statistics.activatedArticlesCount)));
}
exports.default = Home;
